import { generatePath } from 'react-router-dom';
import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import {
  HttpActionDto,
  ActionDto,
  TestResponse,
  AIActionCallsResponseDto,
} from '@/Domain/api/Action/dto/Action.dto';
import { HttpTestResponseForm } from '@/Domain/components/Action/HttpRequestActionSheet/TestResponse/TestResponse';
import { HttpActionForm } from '@/Domain/hooks/Action/ApiAction/useHttpRequestActionFormV2.hook';
import { UpdateActionForm } from '@/Domain/hooks/Action/ApiAction/useUpdateActionDetails.hook';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export class ActionsApi {
  static get = (actionId: number): Promise<HttpActionDto> =>
    httpClient
      .get(generatePath(Endpoint.actions.httpRequest.get, { actionId }))
      .then(ApiMapper.toResponseData<HttpActionDto>);

  static update = (actionId: number, data: UpdateActionForm): Promise<ActionDto> =>
    httpClient
      .patch(generatePath(Endpoint.actions.basic.patch, { actionId }), data)
      .then(ApiMapper.toResponseData);

  static updateHttp = (
    actionId: number,
    data: Omit<HttpActionForm, 'body_items_json_enable' | 'body_items_json'> &
      Record<'body_json', any>,
  ): Promise<HttpActionDto> =>
    httpClient
      .put(generatePath(Endpoint.actions.httpRequest.update, { actionId }), data)
      .then(ApiMapper.toResponseData);

  static testRequest = (data: HttpTestResponseForm): Promise<TestResponse> =>
    httpClient
      .post(generatePath(Endpoint.actions.httpRequest.test), data)
      .then(ApiMapper.toResponseData)
      .catch(ApiMapper.toResponseError);

  static calls = (
    actionId: number,
    params: { only_issues: boolean; limit: number; offset: number },
  ): Promise<AIActionCallsResponseDto> =>
    httpClient
      .get(generatePath(Endpoint.actions.basic.calls, { actionId }), { params })
      .then(ApiMapper.toResponseData);
}
